<template>
    <div class="main-header-menu" v-show="isVisible" v-on-click-outside="onClickOutsideHandler">
        <RouterLink @click="isVisible = false" :to="PATHS.MY_TICKETS" v-if="!isMdLarger"> Moje tikety </RouterLink>
        <button @click="clickMyAccount">Můj účet</button>
        <button @click="clickDeposit">Vložit</button>
        <button @click="logout">Odhlásit</button>
        <label for="display-balance">
            <InputSwitch @click.prevent v-model="displayBalance" input-id="display-balance" />
            Zobrazit zůstatek
        </label>
    </div>
</template>

<script lang="ts" setup>
import { computed, watch } from "vue";
import { vOnClickOutside } from "@vueuse/components";
import InputSwitch from "primevue/inputswitch";
import { ngFrameworkLoaded } from "@/shared/ng/ng-integration";
import useIsBreakpoint from "@/shared/composables/use-is-breakpoint";
import { useHeader } from "@/shared/stores/use-header";
import { PATHS } from "@/router/paths";
import { logException } from "@/shared/utils/logger/use-app-logger";

const isVisible = defineModel<boolean>();

const headerStore = useHeader();

const displayBalance = computed({
    get: () => headerStore.displayBalance,
    set: (val) => (headerStore.displayBalance = val),
});

const { isMdLarger } = useIsBreakpoint();

const clickMyAccount = async () => {
    isVisible.value = false;

    try {
        await ngFrameworkLoaded();

        ng_fw.showMyAccount();
    } catch (error) {
        logException("header", error, { message: "An error has occurred while opening My Account" });
    }
};

const clickDeposit = async () => {
    isVisible.value = false;

    try {
        await ngFrameworkLoaded();

        ng_fw.showDeposit();
    } catch (error) {
        logException("header", error, { message: "An error has occurred while opening Deposit" });
    }
};

const logout = async () => {
    try {
        await ngFrameworkLoaded();

        ng_fw.logout();
    } catch (error) {
        logException("header", error, { message: "An error has occurred while logging out" });
    }
};

const setVisibleFalse = () => {
    isVisible.value = false;
};

watch(isVisible, (newValue) => {
    if (newValue) {
        window.addEventListener("scroll", setVisibleFalse, { passive: true });
    } else {
        window.removeEventListener("scroll", setVisibleFalse);
    }
});

const onClickOutsideHandler = [
    setVisibleFalse,
    { ignore: [".main-header__profile", ".main-header-button--profile"] },
] as any;
</script>
